/**
 * 用于检测应用是否渲染
 * 只有app.js中oldRender执行完成，dvaStore才创建
 */

let _renderResolve = null
let _renderPromise = new Promise(resolve => {
    _renderResolve = resolve
})

export const resolveRender = () => {
    _renderResolve()
}

export const checkRenderIsReady = () => {
    return _renderPromise
}
